// extracted by mini-css-extract-plugin
module.exports = {"info":"_1Ttrl","infoBetween":"_3X9Nh","infoItem":"_3nJZz","infoItemIcon":"spRWU","infoItemText":"_29IB7"};